import PurchaseSection from './PurchaseSection'

export default PurchaseSection
